<template>
	<div class="acca-bonus">
		<div class="acca-bonus__progress-bar__container">
			<progress-bar
				class="acca-bonus__progress-bar"
				:width="(percentage * 100) / max"
				:label="`${$options.filters.currency(bonus)} (${percentage}%)`"
			/>

			<svg
				width="15"
				height="14"
				viewBox="0 0 10 11"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				style="margin-left: 5px"
				@click="canShowBottomSheet = true"
			>
				<path
					d="M5 0.40625C5.85938 0.40625 6.67969 0.640625 7.42188 1.07031C8.16406 1.5 8.75 2.08594 9.17969 2.82812C9.60938 3.57031 9.84375 4.39062 9.84375 5.25C9.84375 6.12891 9.60938 6.92969 9.17969 7.67188C8.75 8.41406 8.16406 9.01953 7.42188 9.44922C6.67969 9.87891 5.85938 10.0938 5 10.0938C4.12109 10.0938 3.32031 9.87891 2.57812 9.44922C1.83594 9.01953 1.23047 8.41406 0.800781 7.67188C0.371094 6.92969 0.15625 6.12891 0.15625 5.25C0.15625 4.39062 0.371094 3.57031 0.800781 2.82812C1.23047 2.08594 1.83594 1.5 2.57812 1.07031C3.32031 0.640625 4.12109 0.40625 5 0.40625ZM5 2.55469C4.76562 2.55469 4.57031 2.65234 4.41406 2.80859C4.25781 2.96484 4.17969 3.16016 4.17969 3.375C4.17969 3.60938 4.25781 3.80469 4.41406 3.96094C4.57031 4.11719 4.76562 4.19531 5 4.19531C5.21484 4.19531 5.41016 4.11719 5.56641 3.96094C5.72266 3.80469 5.82031 3.60938 5.82031 3.375C5.82031 3.16016 5.72266 2.96484 5.56641 2.80859C5.41016 2.65234 5.21484 2.55469 5 2.55469ZM6.09375 7.51562V7.04688C6.09375 6.98828 6.05469 6.92969 6.01562 6.89062C5.97656 6.85156 5.91797 6.8125 5.85938 6.8125H5.625V4.85938C5.625 4.80078 5.58594 4.74219 5.54688 4.70312C5.50781 4.66406 5.44922 4.625 5.39062 4.625H4.14062C4.0625 4.625 4.00391 4.66406 3.96484 4.70312C3.92578 4.74219 3.90625 4.80078 3.90625 4.85938V5.32812C3.90625 5.40625 3.92578 5.46484 3.96484 5.50391C4.00391 5.54297 4.0625 5.5625 4.14062 5.5625H4.375V6.8125H4.14062C4.0625 6.8125 4.00391 6.85156 3.96484 6.89062C3.92578 6.92969 3.90625 6.98828 3.90625 7.04688V7.51562C3.90625 7.59375 3.92578 7.65234 3.96484 7.69141C4.00391 7.73047 4.0625 7.75 4.14062 7.75H5.85938C5.91797 7.75 5.97656 7.73047 6.01562 7.69141C6.05469 7.65234 6.09375 7.59375 6.09375 7.51562Z"
					fill="#60981A"
				/>
			</svg>
		</div>
		<p class="acca-bonus__desc" v-if="percentage < max">
			Add {{ nextLevel.next - validNoOfBets }} selection{{
				nextLevel.next - validNoOfBets > 1 ? `s` : ``
			}}
			with {{ env.accaBonusMinimumOdd }} or more odds to get a
			{{ nextLevel.perc }}% {{ env.accaBonusProductName }}
		</p>
		<p class="acca-bonus__desc" v-else>
			You have reached the maximum {{ env.accaBonusProductName }} 🎉
		</p>

		<a class="acca-bonus__link" @click="showTerms = true"
			>Learn more about {{ env.accaBonusProductName }}</a
		>
		<hr class="acca-bonus__divider" />
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div style="padding: 20px">
				<p class="acca-bonus__title">
					{{ percentage }}% {{ env.accaBonusProductName }}
				</p>
				<div class="acca-bonus__header">
					<p class="acca-bonus__header__desc">
						Possible Win
						{{ (possibleWin + bonus || 0) | currency }}

						<b
							>({{ (possibleWin || 0) | currency }} + {{ bonus | currency }})</b
						>
					</p>
				</div>
				<progress-bar
					class="acca-bonus__progress-bar"
					style="margin-bottom: 10px"
					:width="(percentage * 100) / max"
					:label="`${$options.filters.currency(bonus)} (${percentage}%)`"
				/>

				<p class="acca-bonus__indicator">
					<span>{{ validNoOfBets }} valid selections</span>
					<span
						>{{ validNoOfBets }} of
						{{ Object.keys(env.accaBonusMatrix).length }} selections</span
					>
				</p>

				<p class="acca-bonus__desc" v-if="percentage < max">
					Add {{ nextLevel.next - validNoOfBets }} selection{{
						nextLevel.next - validNoOfBets > 1 ? `s` : ``
					}}
					with {{ env.accaBonusMinimumOdd }} or more odds to get a
					{{ nextLevel.perc }}% {{ env.accaBonusProductName }}
				</p>
				<p class="acca-bonus__desc" v-else>
					You have reached the maximum {{ env.accaBonusProductName }} of
					{{ max }}%🎉
				</p>

				<p class="acca-bonus__desc">
					As you add more games to your betslip with an odd of
					{{ env.accaBonusMinimumOdd }} or more, your possible winning is
					multipled upto
					{{ env.accaBonusMatrix[Object.keys(env.accaBonusMatrix).length] }}%
					for {{ Object.keys(env.accaBonusMatrix).length }} games.
				</p>
				<a class="acca-bonus__link" @click="showTerms = true"
					>Learn more about {{ env.accaBonusProductName }}</a
				>
			</div>

			<button class="sheet-filter__reset" @click="closeBottomSheet">
				Cancel
			</button>
		</bottom-sheet>

		<modal
			v-if="showTerms"
			:show="showTerms"
			@close="showTerms = false"
			:size="'auto'"
		>
			<acca-terms @close="showTerms = false" />
		</modal>
	</div>
</template>

<script>
import AccaTerms from "../Shared/AccaTerms.vue";
import ProgressBar from "../Shared/ProgressBar.vue";

export default {
	components: { ProgressBar, AccaTerms },
	name: "acca-bonus",
	props: {
		bets: {
			type: Array,
			required: true,
			default: () => [],
		},
		possibleWin: {
			type: Number,
			required: true,
			default: 0,
		},
	},
	data() {
		return {
			canShowBottomSheet: false,
			collapsed: true,
			showTerms: false,
		};
	},
	mounted() {
		this.$emit("mounted");
	},
	computed: {
		percentage() {
			if (!this.validNoOfBets) return 0;
			if (!this.env.accaBonusMatrix.hasOwnProperty(this.validNoOfBets))
				return this.env.accaBonusMatrix[
					Object.keys(this.env.accaBonusMatrix).length
				];

			return this.env.accaBonusMatrix[this.validNoOfBets];
		},
		validNoOfBets() {
			return this.bets.filter(
				(bet) => Number(bet.odd.odd_value) >= this.env.accaBonusMinimumOdd
			).length;
		},
		max() {
			const max =
				this.env.accaBonusMatrix[Object.keys(this.env.accaBonusMatrix).length];
			return max;
		},
		nextLevel() {
			let next =
				this.validNoOfBets < this.env.accaBonusMinSelections
					? this.env.accaBonusMinSelections
					: this.validNoOfBets + 1;

			return { next, perc: this.env.accaBonusMatrix[next] };
		},
		bonus() {
			return this.possibleWin * (this.percentage * 0.01) > this.env.maxAccaBonus
				? this.env.maxAccaBonus
				: Math.trunc(this.possibleWin * this.percentage) / 100 || 0;
		},
	},
	methods: {
		showBottomSheet() {
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss">
.acca-bonus {
	padding: 10px;
	&__header {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 10px;
		&__desc {
			margin: 0;
		}
		&__caret {
			fill: var(--green);
			&.closed {
				transform: rotate(-90deg);
			}
		}
	}
	&__title {
		font-size: var(--font-large);
		margin: 0;
		margin-bottom: 15px;
	}
	&__desc {
		font-size: var(--font-smallest);
		margin: 0;
		margin-bottom: 10px;
	}
	&__link {
		font-size: var(--font-small);
		margin-bottom: 10px;
		box-sizing: border-box;
		text-decoration: none;
		display: inline-block;
		color: var(--green);
		font-weight: bold;
	}
	&__divider {
		background-color: var(--light-gray);
		border-color: var(--light-gray);
		border-width: 0px;
		height: 1px;
		margin: 0;
	}
	&__progress-bar {
		width: calc(100%);
		margin: 0 auto;
		&__container {
			margin-bottom: 10px;
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
		}
	}
	&__indicator {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: var(--font-smallest);
		color: var(--light-black);
		margin: 0;
		margin-bottom: 15px;
	}
}
</style>
